import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { VariableBenefitRecurringPaymentFormGroup } from '../../../../../../records/components/members/ip-view-member-record/components/ip-member-record-variable-benefit-configuration/form-groups/variable-benefit-recurring-payment-form-group';

@Component({
  selector: 'app-variable-benefit-recurring-payment-details-card',
  templateUrl: './variable-benefit-recurring-payment-details-card.component.html',
  styleUrls: ['./variable-benefit-recurring-payment-details-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VariableBenefitRecurringPaymentDetailsCardComponent {
  @Input() header!: string;
  @Input() recurringPaymentForm!: VariableBenefitRecurringPaymentFormGroup;
  @Input() isMemberPortal = false;
}
